<body>
  <header class="flex justify-center items-center">
    <img src="cb-logo.svg" />
  </header>
  <main class="loan-page">
    <h1>Reset Password</h1>
    <div class="loan-section max-w-500 w-full">
      @if (resetStep === 'password') {
        <p class="m-0">Your new password must be different from your previously used passwords.</p>
        <app-loan-input label="New Password" [control]="password1Control" type="password" [enableVisibilityToggle]="true" />
        <app-loan-input label="Confirm Password" [control]="password2Control" type="password" [enableVisibilityToggle]="true" />
      }
      @if (resetStep === 'otp') {
        <p class="m-0">Administrators must get a one-time code from another administrator to reset their password.</p>
        <p class="m-0">Resetting password for <strong>{{ adminEmail }}</strong>. Enter the email of another administrator who will receive the code:</p>
        <app-loan-input label="Colleague's email" [control]="colleagueEmailControl" placeholder="admin@example.com" type="email" />
        <div class="flex justify-between items-center pt-10">
          <app-button (click)="sendOtpLoading ? null : sendOtpToColleague()">{{ sendOtpLoading ? 'Sending…' : 'Send code to colleague' }}</app-button>
        </div>
        @if (otpSentTo) {
          <p class="pt-10 text-success">{{ message }}</p>
        }
        <app-loan-input label="Verification code" [control]="adminOtpControl" />
      }
      @if (message && resetStep === 'password') {
        <p class="pt-10">{{ message }}</p>
      }
      @if (error) {
        <p class="pt-10 text-err">{{ error }}</p>
      }
      <div class="flex justify-between items-center pt-10">
        <app-button (click)="isSubmitting ? null : onSaveClick($event)">{{ isSubmitting ? 'Saving…' : 'Save' }}</app-button>
      </div>
    </div>
  </main>
</body>
